module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-11-sm-a8d94cd2ee4679691188828339f21418.png";